<template>
  <v-list-group v-model="item.active" no-action>
    <v-icon slot="prependIcon" :color="`${item.color}`">{{item.icon}}</v-icon>
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title v-text="item.title"></v-list-item-title>
      </v-list-item-content>
    </template>

    <v-list-item :disabled="!subItem.permission" v-for="subItem in item.subItems.filter(x => x.permission)" :key="subItem.title" :to="{name: subItem.route}" exact>
      <v-list-item-content>
        <v-list-item-title v-text="subItem.title"></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list-group>
</template>

<script>
export default {
  props: {
    itemData: {
      required: true,
      type: Object
    },
    itemDisabled: {
      required: false,
      type: Boolean
    }
  },
  data () {
    return {
      item: null
    }
  },
  created () {
    this.item = { ...this.itemData }
  },
  watch: {
    'itemData.subItems': {
      handler: function(newVal) {
        this.item.subItems = newVal
      },
      deep: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-group--active.primary--text {
  color: inherit !important;
}
</style>
